(() => {
var $9ee8e0e99c26bb42$exports = {};
(function() {
    /*
   WooCommerce Apple Pay Handler
   Version 4.7.0

   Copyright (c) 2016, SkyVerge, Inc.
   Licensed under the GNU General Public License v3.0
   http://www.gnu.org/licenses/gpl-3.0.html
  */ jQuery(function($) {
        "use strict";
        // The WooCommerce Apple Pay handler base class.
        // @since 4.7.0
        window.SV_WC_Apple_Pay_Handler_v6_2_4 = class SV_WC_Apple_Pay_Handler_v6_2_4 {
            // Constructs the handler.
            // @since 4.7.0
            constructor(args){
                // Initializes the product page.
                // @since 5.6.0
                this.init_product_page = this.init_product_page.bind(this);
                // Initializes the cart page.
                // @since 5.6.0
                this.init_cart_page = this.init_cart_page.bind(this);
                // Initializes the checkout page.
                // @since 5.6.0
                this.init_checkout_page = this.init_checkout_page.bind(this);
                // The callback for after the merchant data is validated.
                // @since 4.7.0
                this.on_validate_merchant = this.on_validate_merchant.bind(this);
                // Validates the merchant data.
                // @since 4.7.0
                // @return object
                this.validate_merchant = this.validate_merchant.bind(this);
                // Fires after a payment method has been selected.
                // @since 4.7.0
                this.on_payment_method_selected = this.on_payment_method_selected.bind(this);
                // Fires after a shipping contact has been selected.
                // @since 4.7.0
                this.on_shipping_contact_selected = this.on_shipping_contact_selected.bind(this);
                // Fires after a shipping method has been selected.
                // @since 4.7.0
                this.on_shipping_method_selected = this.on_shipping_method_selected.bind(this);
                // The callback for after the payment data is authorized.
                // @since 4.7.0
                this.on_payment_authorized = this.on_payment_authorized.bind(this);
                // Processes the transaction data.
                // @since 4.7.0
                this.process_authorization = this.process_authorization.bind(this);
                // The callback for when the payment card is cancelled/dismissed.
                // @since 4.7.0
                this.on_cancel_payment = this.on_cancel_payment.bind(this);
                // Resets the payment request via AJAX.
                // Extending handlers can call this on change events to refresh the data.
                // @since 4.7.0
                this.reset_payment_request = this.reset_payment_request.bind(this);
                // Gets the payment request via AJAX.
                // @since 4.7.0
                this.get_payment_request = this.get_payment_request.bind(this);
                this.gateway_id = args.gateway_id;
                this.gateway_slug = args.gateway_slug;
                this.merchant_id = args.merchant_id;
                this.ajax_url = args.ajax_url;
                this.validate_nonce = args.validate_nonce;
                this.recalculate_totals_nonce = args.recalculate_totals_nonce;
                this.process_nonce = args.process_nonce;
                this.payment_request = args.payment_request;
                this.generic_error = args.generic_error;
                this.wrapper = '.sv-wc-external-checkout';
                this.container = '.buttons-container';
                this.button = '.sv-wc-apple-pay-button';
            }
            // Determines if Apple Pay is available.
            // @since 4.7.0
            // @return bool
            is_available() {
                if (!window.ApplePaySession) return false;
                return ApplePaySession.canMakePaymentsWithActiveCard(this.merchant_id).then((canMakePayments)=>{
                    return canMakePayments;
                });
            }
            // Initializes the handler.
            // @since 4.7.0
            init() {
                // hide the wrapper if Apple Pay is the only button
                if ($(this.container).children().length === 1) $(this.wrapper).hide();
                if (!this.is_available()) return;
                // initialize for the various pages
                if ($('form.cart').length) this.init_product_page();
                else if ($('form.woocommerce-cart-form').length) this.init_cart_page();
                else if ($('form.woocommerce-checkout').length) this.init_checkout_page();
                // bail if no UI was initialized
                if (!this.ui_element) return;
                if (this.payment_request) {
                    $(this.button).show();
                    $(this.wrapper).show();
                }
                return $(document.body).on('click', '.sv-wc-apple-pay-button', (e)=>{
                    var error;
                    e.preventDefault();
                    this.block_ui();
                    try {
                        this.session = this.get_new_session(this.payment_request);
                        // set the payment card events
                        this.session.onvalidatemerchant = (event)=>{
                            return this.on_validate_merchant(event);
                        };
                        this.session.onpaymentmethodselected = (event)=>{
                            return this.on_payment_method_selected(event);
                        };
                        this.session.onshippingcontactselected = (event)=>{
                            return this.on_shipping_contact_selected(event);
                        };
                        this.session.onshippingmethodselected = (event)=>{
                            return this.on_shipping_method_selected(event);
                        };
                        this.session.onpaymentauthorized = (event)=>{
                            return this.on_payment_authorized(event);
                        };
                        this.session.oncancel = (event)=>{
                            return this.on_cancel_payment(event);
                        };
                        return this.session.begin();
                    } catch (error1) {
                        error = error1;
                        return this.fail_payment(error);
                    }
                });
            }
            init_product_page() {
                return this.ui_element = $('form.cart');
            }
            init_cart_page() {
                this.ui_element = $('form.woocommerce-cart-form').parents('div.woocommerce');
                // re-init if the cart totals are updated
                return $(document.body).on('updated_cart_totals', ()=>{
                    return this.reset_payment_request();
                });
            }
            init_checkout_page() {
                this.ui_element = $('form.woocommerce-checkout');
                return $(document.body).on('updated_checkout', ()=>{
                    // re-init if the checkout is updated
                    return this.reset_payment_request();
                });
            }
            // Gets a new Apple Pay session.
            // @since 5.6.0
            // @param [Object] payment_request payment request object
            // @return ApplePaySession
            get_new_session(payment_request) {
                return new ApplePaySession(this.get_sdk_version(), payment_request);
            }
            // Gets the Apple SDK version to use.
            // @since 5.6.0
            // @return int
            get_sdk_version() {
                return 2;
            }
            on_validate_merchant(event) {
                return this.validate_merchant(event.validationURL).then((merchant_session)=>{
                    merchant_session = JSON.parse(merchant_session);
                    return this.session.completeMerchantValidation(merchant_session);
                }, (response)=>{
                    this.session.abort();
                    return this.fail_payment('Merchant could no be validated. ' + response.message);
                });
            }
            validate_merchant(url) {
                return new Promise((resolve, reject)=>{
                    var data;
                    data = {
                        'action': `wc_${this.gateway_id}_apple_pay_validate_merchant`,
                        'nonce': this.validate_nonce,
                        'merchant_id': this.merchant_id,
                        'url': url
                    };
                    // retrieve a payment request object
                    return $.post(this.ajax_url, data, (response)=>{
                        if (response.success) return resolve(response.data);
                        else return reject(response.data);
                    });
                });
            }
            on_payment_method_selected(event) {
                return new Promise((resolve, reject)=>{
                    var data;
                    data = {
                        'action': `wc_${this.gateway_id}_apple_pay_recalculate_totals`,
                        'nonce': this.recalculate_totals_nonce
                    };
                    // retrieve a payment request object
                    return $.post(this.ajax_url, data, (response)=>{
                        if (response.success) {
                            data = response.data;
                            return resolve(this.session.completePaymentMethodSelection(data.total, data.line_items));
                        } else {
                            console.error('[Apple Pay] Error selecting a shipping contact. ' + response.data.message);
                            return reject(this.session.completePaymentMethodSelection(this.payment_request.total, this.payment_request.lineItems));
                        }
                    });
                });
            }
            on_shipping_contact_selected(event) {
                return new Promise((resolve, reject)=>{
                    var data;
                    data = {
                        'action': `wc_${this.gateway_id}_apple_pay_recalculate_totals`,
                        'nonce': this.recalculate_totals_nonce,
                        'contact': event.shippingContact
                    };
                    // retrieve a payment request object
                    return $.post(this.ajax_url, data, (response)=>{
                        if (response.success) {
                            data = response.data;
                            return resolve(this.session.completeShippingContactSelection(ApplePaySession.STATUS_SUCCESS, data.shipping_methods, data.total, data.line_items));
                        } else {
                            console.error('[Apple Pay] Error selecting a shipping contact. ' + response.data.message);
                            return reject(this.session.completeShippingContactSelection(ApplePaySession.STATUS_FAILURE, [], this.payment_request.total, this.payment_request.lineItems));
                        }
                    });
                });
            }
            on_shipping_method_selected(event) {
                return new Promise((resolve, reject)=>{
                    var data;
                    data = {
                        'action': `wc_${this.gateway_id}_apple_pay_recalculate_totals`,
                        'nonce': this.recalculate_totals_nonce,
                        'method': event.shippingMethod.identifier
                    };
                    // retrieve a payment request object
                    return $.post(this.ajax_url, data, (response)=>{
                        if (response.success) {
                            data = response.data;
                            return resolve(this.session.completeShippingMethodSelection(ApplePaySession.STATUS_SUCCESS, data.total, data.line_items));
                        } else {
                            console.error('[Apple Pay] Error selecting a shipping method. ' + response.data.message);
                            return reject(this.session.completeShippingMethodSelection(ApplePaySession.STATUS_FAILURE, this.payment_request.total, this.payment_request.lineItems));
                        }
                    });
                });
            }
            on_payment_authorized(event) {
                return this.process_authorization(event.payment).then((response)=>{
                    this.set_payment_status(true);
                    return this.complete_purchase(response);
                }, (response)=>{
                    this.set_payment_status(false);
                    return this.fail_payment('Payment could no be processed. ' + response.message);
                });
            }
            process_authorization(payment) {
                return new Promise((resolve, reject)=>{
                    var data;
                    data = {
                        action: `wc_${this.gateway_id}_apple_pay_process_payment`,
                        nonce: this.process_nonce,
                        payment: JSON.stringify(payment)
                    };
                    return $.post(this.ajax_url, data, (response)=>{
                        if (response.success) return resolve(response.data);
                        else return reject(response.data);
                    });
                });
            }
            on_cancel_payment(event) {
                return this.unblock_ui();
            }
            // Completes the purchase based on the gateway result.
            // @since 4.7.0
            complete_purchase(response) {
                return window.location = response.redirect;
            }
            // Fails the purchase based on the gateway result.
            // @since 4.7.0
            fail_payment(error) {
                console.error('[Apple Pay] ' + error);
                this.unblock_ui();
                return this.render_errors([
                    this.generic_error
                ]);
            }
            // Sets the Apple Pay payment status depending on the gateway result.
            // @since 4.7.0
            set_payment_status(success) {
                var status;
                if (success) status = ApplePaySession.STATUS_SUCCESS;
                else status = ApplePaySession.STATUS_FAILURE;
                return this.session.completePayment(status);
            }
            reset_payment_request(data = {}) {
                this.block_ui();
                return this.get_payment_request(data).then((response)=>{
                    $(this.button).show();
                    $(this.wrapper).show();
                    this.payment_request = JSON.parse(response);
                    return this.unblock_ui();
                }, (response)=>{
                    console.error('[Apple Pay] Could not build payment request. ' + response.message);
                    $(this.button).hide();
                    // hide the wrapper if Apple Pay is the only button
                    if ($(this.container).children().length === 1) $(this.wrapper).hide();
                    return this.unblock_ui();
                });
            }
            get_payment_request(data) {
                return new Promise((resolve, reject)=>{
                    var base_data;
                    base_data = {
                        'action': `wc_${this.gateway_id}_apple_pay_get_payment_request`
                    };
                    $.extend(data, base_data);
                    // retrieve a payment request object
                    return $.post(this.ajax_url, data, (response)=>{
                        if (response.success) return resolve(response.data);
                        else return reject(response.data);
                    });
                });
            }
            // Renders any new errors and bring them into the viewport.
            // @since 4.7.0
            render_errors(errors) {
                // hide and remove any previous errors
                $('.woocommerce-error, .woocommerce-message').remove();
                // add errors
                this.ui_element.prepend('<ul class="woocommerce-error"><li>' + errors.join('</li><li>') + '</li></ul>');
                // unblock UI
                this.ui_element.removeClass('processing').unblock();
                // scroll to top
                return $('html, body').animate({
                    scrollTop: this.ui_element.offset().top - 100
                }, 1000);
            }
            // Blocks the payment form UI.
            // @since 4.7.0
            block_ui() {
                return this.ui_element.block({
                    message: null,
                    overlayCSS: {
                        background: '#fff',
                        opacity: 0.6
                    }
                });
            }
            // Unblocks the payment form UI.
            // @since 4.7.0
            unblock_ui() {
                return this.ui_element.unblock();
            }
        };
        // dispatch loaded event
        return $(document.body).trigger('sv_wc_apple_pay_handler_v6_2_4_loaded');
    });
}).call($9ee8e0e99c26bb42$exports);

})();
//# sourceMappingURL=sv-wc-payment-gateway-apple-pay.js.map
